"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link SelloutTerminationReportFilterDTO}.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportFilterDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTerminationReportFilterDTOConverter, _DataObjectConverter_);

  function SelloutTerminationReportFilterDTOConverter() {
    _classCallCheck(this, SelloutTerminationReportFilterDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportFilterDTOConverter).apply(this, arguments));
  }

  return SelloutTerminationReportFilterDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTerminationReportFilterDTOConverter = SelloutTerminationReportFilterDTOConverter;